<template>
  <div class="container_top">
    <div class="container_auto">
      <el-row>
        <el-col :span="8">
          <div class="header">
            <!-- <a :href="homePage">
              <img :src="logoUrl" />
            </a> -->
          </div>
        </el-col>
        <el-col :span="16" class="top_right_confim">
          <!-- <span class="img_tel">
            <img src="@/assets/image/tel-top.png" />
          </span>-->
          <span class="login_out" title="退出登录" @click="_logOut"
            >退出登录</span
          >
          <span class="login_out" href="javascript:;" @click="live800"
            >联系客服</span
          >
          <!-- <span class="net_text">
            <a :href="homePage">宝富官网</a>
          </span> -->
          <span class="wellcome_text">欢迎你!</span>
          <span class="user-item user-name">{{ this.userName }}</span>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { base64 } from "@/utils";
import urlConfig from "@/axios/config.js";
export default {
  data() {
    return {
      userName: "",
      logoUrl: require("@/assets/image/logo_jf.png"),
    };
  },
  computed: {
    homePage() {
      // if (this.$store.state.userRole == 4 || this.$store.state.userRole == 5) {
      //   return "/";
      // } else {
        return "https://www.etb037.com";
      //}
    },
  },
  methods: {
    changeLogo() {
      var url = window.location.host;
      console.log(url.indexOf("etb"));
      if (url.indexOf("etb") != -1) {
        this.logoUrl = require("@/assets/image/logo_bfjy.png");
      }
    },
    _setName() {
      let info = this.$store.state.userInfo;
      this.userName = info.jfUser ? info.jfUser.name : info.name;
    },
    _logOut() {
      const _this = this;
      // this.$message({
      //   message: '正在退出...',
      //   duration: '1200',
      //   onClose() {
      //     _this.$cookie.delete('remember')
      //     location.reload()

      //     // FIXME:
      //     // _this.$router.push({
      //     //   path: '/login'
      //     // })
      //   }
      // });
      this.$confirm("是否确定退出用户中心?", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          _this.$cookie.delete("remember");
          window.location.href="https://www.xinyuebd.com/"
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '取消退出'
          // });
        });
    },
    live800() {
      var url = urlConfig.BASE_LIVE800_URL;
      var h = Math.round(($(window).height() - 606) / 2);
      var w = Math.round(($(window).width() - 740) / 2);
      typeof analysesData == "function" && analysesData("2", "2", "");
      window.open(
        url,
        "newwindow",
        "top=" +
          h +
          ",left=" +
          w +
          ",height=606,width=740,toolbar=no,menubar=no,scrollbars=no,resizable=yes,location=no,status=no"
      );
      return false;
    },
  },
  mounted() {
    this._setName();
    this.changeLogo();
  },
};
</script>

<style lang="scss">
@import "~scss/common/header.scss";
</style>


// WEBPACK FOOTER //
// src/views/common/header.vue